interface ErrorObj {
  name: string;
  message: string;
}

interface OptsObj {
  metaData?: object;
  severity?: 'info' | 'warning' | 'error';
}

export type ReportError = Error | ErrorObj | string;

export default function reportError(e: ReportError, options?: OptsObj) {
  if (global.Bugsnag) {
    global.Bugsnag.notify(e, options);
  }
  if (!__SERVER__) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}
